import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../ui';


export const AnalyticsInfoTooltip: FC<{children: React.ReactNode}> = ({children}) => {


    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className='cursor-pointer text-base-mutedForeground'>
              <FontAwesomeIcon icon="fa-regular fa-circle-info" />
            </div>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            align="center"
            className="rounded-md border border-base-popover bg-base-popover shadow-md py-[6px] px-[12px]"
          >
            <span className="text-p-s text-base-popoverForeground">
              {children}
            </span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
}